import { Controller } from "@hotwired/stimulus"

// Il nome del file al passo 3 di pages/VerificaBandi.js (classi[doc].nome_file e a_mano): la spunta «Nome letto male»
// sceglie il nome dal link (o nessuno), «Correggi il nome a mano» apre il campo con il nome attuale, «Annulla» lo chiude
// e toglie la correzione. Il valore va nel campo nascosto `valore` ("" = nessuna correzione); il campo a mano mostra
// la correzione o il nome del file. I clic emettono "change" sul campo nascosto (l'unità diventa modificata).
export default class extends Controller {
  static targets = ["valore", "spunta", "mano", "campo", "apri"]
  static values = { nome: String, proposto: String }

  connect() {
    this.mostra()
  }

  spunta(event) {
    this.valoreTarget.value = event.target.checked ? this.propostoValue : ""
    this.campoTarget.value = this.valoreTarget.value || this.nomeValue
  }

  scrivi() {
    this.valoreTarget.value = this.campoTarget.value
    this.mostra()
  }

  apri() {
    this.element.dataset.aMano = ""
    this.valoreTarget.value = this.nomeValue
    this.campoTarget.value = this.nomeValue
    this.cambiato()
  }

  annulla() {
    delete this.element.dataset.aMano
    this.valoreTarget.value = ""
    this.campoTarget.value = this.nomeValue
    this.cambiato()
  }

  cambiato() {
    this.mostra()
    this.valoreTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  mostra() {
    const aMano = this.element.dataset.aMano !== undefined
    this.manoTarget.hidden = !aMano
    this.apriTarget.hidden = aMano
    if (this.hasSpuntaTarget) this.spuntaTarget.checked = this.propostoValue !== "" && this.valoreTarget.value === this.propostoValue
  }
}
